import { render } from "./GenericCustomFormV2.vue?vue&type=template&id=4b4c4876"
import script from "./GenericCustomFormV2.vue?vue&type=script&lang=js"
export * from "./GenericCustomFormV2.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__